import React from "react";

import clsx from "clsx";

import { Table } from "@devexpress/dx-react-grid-material-ui";

export default function Cell(props) {
  const className = clsx({
    monospace: props.tableColumn.column.monospace !== false,
  });

  return <Table.Cell className={className} {...props} />;
}
